import { gql } from '@apollo/client';

export const ADD_INSTITUTION_TO_INSTITUTION_PORTAL = gql`
  mutation AddInstitutionToInstitutionPortal($id: ID!) {
    institution: addInstitutionToInstitutionPortal(id: $id) {
      id
    }
  }
`;
